var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F0EDE9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2832 20.7999C10.5847 20.7999 9.73543 20.7999 9.13079 20.4374C8.73563 20.2004 8.41727 19.8616 8.2118 19.4593C7.89743 18.8437 7.98194 18.0298 8.15095 16.4019C8.29203 15.043 8.36257 14.3636 8.70947 13.8646C8.93723 13.537 9.24527 13.2684 9.60638 13.0828C10.1564 12.7999 10.8653 12.7999 12.2832 12.7999H19.7168C21.1347 12.7999 21.8436 12.7999 22.3936 13.0828C22.7547 13.2684 23.0628 13.537 23.2906 13.8646C23.6374 14.3636 23.708 15.043 23.849 16.4019C24.0181 18.0298 24.1026 18.8437 23.7882 19.4593C23.5827 19.8616 23.2644 20.2004 22.8692 20.4374C22.2646 20.7999 21.4154 20.7999 19.7168 20.7999",
    stroke: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.7999V11.1999C20 9.69138 20 8.93713 19.5314 8.46851C19.0627 7.99988 18.3085 7.99988 16.8 7.99988H15.2C13.6915 7.99988 12.9373 7.99988 12.4686 8.46851C12 8.93713 12 9.69138 12 11.1999V12.7999",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.591 19.1999H14.409C13.8608 19.1999 13.5867 19.1999 13.3535 19.287C13.0425 19.4031 12.7762 19.6287 12.597 19.9278C12.4625 20.1522 12.396 20.4408 12.2631 21.0178C12.0553 21.9195 11.9514 22.3703 12.0221 22.7318C12.1163 23.2138 12.4099 23.6218 12.818 23.8378C13.1241 23.9999 13.5524 23.9999 14.409 23.9999H17.591C18.4476 23.9999 18.8759 23.9999 19.182 23.8378C19.5901 23.6218 19.8838 23.2138 19.9779 22.7318C20.0486 22.3703 19.9447 21.9195 19.737 21.0178C19.604 20.4408 19.5374 20.1522 19.403 19.9278C19.2238 19.6287 18.9575 19.4031 18.6466 19.287C18.4133 19.1999 18.1392 19.1999 17.591 19.1999Z",
    stroke: "#141B34",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8008 15.9999H20.808",
    stroke: "#141B34",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.3d3acbd58b187c61675073f2be21f88c.svg";
export { ForwardRef as ReactComponent };